import React from 'react';

import Container from '@/components/@base/container';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import FAQAccordion from '@/components/shared/components/faq/accordion';
import Props from '@/components/shared/components/faq/type';
import RoundedIcon from '@/components/shared/components/icon/rounded';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import imagesList from '@/constant/images-list';
import localization from '@/constant/localization';

export default function FAQ({ faqList }: Props) {
  return (
    <>
      <IconTextCombo
        id='faq'
        Icon={
          <RoundedIcon
            icon={
              <XImage
                src={imagesList.icons.faqIcon}
                alt={localization.faq}
                width={20}
                height={20}
                className='rounded-full'
              />
            }
          />
        }
        textClassName='text-base font-bold text-[#424B57]'
        wrapperClassName='max-w-max mb-4 md:mb-[30px]'
        headingType={HEADING_TYPE.H2}
        title={localization.faq}
      />

      <Container className='rounded-lg bg-[#F9FAFC] p-2.5 md:p-5'>
        {faqList.map((item, index) => (
          <Container key={index} className='group'>
            <FAQAccordion faq={item} />
          </Container>
        ))}
      </Container>
    </>
  );
}
